import React, {FC} from "react";
import {Box, Button} from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  onApprove: () => void;
  onReject: () => void;
  onRevision: () => void;
};

const ApprovalActionButtons: FC<Props> = ({
  onApprove,
  onReject,
  onRevision,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" marginBottom="3em">
      <Button
        classes={{root: classes.approvalActionButton}}
        color="primary"
        variant="contained"
        onClick={onApprove}
      >
        Approve
      </Button>
      <Button
        classes={{textSecondary: classes.buttonSecondary}}
        onClick={onReject}
        color="secondary"
      >
        Reject
      </Button>
      <Button
        className={classes.revisionButton}
        onClick={onRevision}
        color="primary"
        variant="text"
      >
        Revision
      </Button>
    </Box>
  );
};

export default ApprovalActionButtons;
